import { InjectionToken } from '@angular/core';

export type SetRoutingContextFn = (context: string) => void;
export const SET_ROUTING_CONTEXT = new InjectionToken<SetRoutingContextFn>('SET_ROUTING_CONTEXT');

export enum RoutingContext {
  PDP = 'PDP',
}
